import Vue from 'vue';
import VueRouter from 'vue-router';
import Decors from '../components/structure/Decors/Decors';
import Login from '../components/Login';
import Packagings from "../components/structure/Packaging/Packagings";
import Selections from "../templates/Selections";
import Translations from "../templates/Translations";
import Users from "../templates/Users";
import ArticlesDecorsPackagingLandingPage from "../templates/ArticlesDecorsPackagingLandingPage";
import SharedSelection from "../templates/SharedSelection";

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'Classen Dashboard | Login',
      metaTags: [
        {
          name: 'description',
          content: 'Login',
        },
      ],
    },
  },

  {
    path: '/',
    name: 'root',
    component: ArticlesDecorsPackagingLandingPage,
    meta: {
      title: 'Classen Dashboard | Products',
      metaTags: [
        {
          name: 'description',
          content: 'Dashboard Products',
        },
        {
          property: 'og:description',
          content: 'Dashboard Products'
        }
      ],
    },
  },

  {
    path: '/products/',
    name: 'Products',
    component: ArticlesDecorsPackagingLandingPage,
    meta: {
      title: 'Classen Dashboard | Products',
      metaTags: [
        {
          name: 'description',
          content: 'Dashboard Products',
        },
      ],
    },
  },

  {
    path: '/decors',
    name: 'Decors',
    component: Decors,
    meta: {
      title: 'Classen Dashboard | Login',
      metaTags: [
        {
          name: 'description',
          content: 'Dashboard Decors',
        },
      ],
    },
  },

  {
    path: '/packaging',
    name: 'Packaging',
    component: Packagings,
    meta: {
      title: 'Classen Dashboard | Packaging',
      metaTags: [
        {
          name: 'description',
          content: 'Packaging Dashboard',
        },
      ],
    },
  },

  {
    path: '/selections',
    name: 'Selections',
    component: Selections,
    meta: {
      title: 'Classen Dashboard | Selections',
      metaTags: [
        {
          name: 'description',
          content: 'Selections Dashboard',
        },
      ],
    },
  },

  {
    path: '/selection/:id',
    name: 'Selection',
    component: SharedSelection,
    meta: {
      title: 'Classen Dashboard | Selection',
      metaTags: [
        {
          name: 'description',
          content: 'Selections Dashboard',
        },
      ],
    },
  },

  {
    path: '/translations',
    name: 'Translations',
    component: Translations,
    meta: {
      title: 'Classen Dashboard | Translations',
      metaTags: [
        {
          name: 'description',
          content: 'Translations Dashboard',
        },
      ],
    },
  },

  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: {
      title: 'Classen Dashboard | Users',
      metaTags: [
        {
          name: 'description',
          content: 'Users Dashboard',
        },
      ],
    },
  },

  {
    path: '/products/:type/:item_id',
    name: 'Products',
    component: ArticlesDecorsPackagingLandingPage,
    meta: {
      title: 'Classen Dashboard | Products',
      metaTags: [
        {
          name: 'description',
          content: 'Dashboard Products',
        },
      ],
    },
  },

  {
    path: '/:type/:item_id',
    name: 'detail',
    component: ArticlesDecorsPackagingLandingPage,
    meta: {
      title: 'Classen Dashboard | Products',
      metaTags: [
        {
          name: 'description',
          content: 'Dashboard Products',
        },
      ],
    },
  },
  {
    path: '/:type',
    name: 'detail',
    component: ArticlesDecorsPackagingLandingPage,
    meta: {
      title: 'Classen Dashboard | Products',
      metaTags: [
        {
          name: 'description',
          content: 'Dashboard Products',
        },
      ],
    },
  },
];

const router = new VueRouter({
  routes,
  mode: 'hash',
  linkedExactActiveClass: 'active',
});

export default router;
